import { render, staticRenderFns } from "./receptionApply.vue?vue&type=template&id=3ba2013a&"
import script from "./receptionApply.vue?vue&type=script&lang=js&"
export * from "./receptionApply.vue?vue&type=script&lang=js&"
import style0 from "./receptionApply.vue?vue&type=style&index=0&id=3ba2013a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports